import { useDispatch, useSelector } from "react-redux";
import {
    getUserSelectedAccountType
} from "../../../../../app/appSelectors";
import { useCallback } from "react";
import { logAppsflyerAction } from "../../../../../app/appActions";
import { LOG_AF_EVENT_NAMES } from "../../../../../app/appConstants";
import { shadowString } from "../../../../../utils/shadowUtils";

function useSelectAccountsHandlers() {
    const dispatch = useDispatch();
    const accountType = useSelector(getUserSelectedAccountType);

    const handleAccountSelectClick = useCallback(() => {
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.MAIN_ACCOUNT_TYPE,
            payload: { account_type: accountType },
        }));
    }, [accountType, dispatch]);

    const handleAccountSelectClose = useCallback(({ newValue, oldValue, source }) => {
        dispatch(logAppsflyerAction({
            name: LOG_AF_EVENT_NAMES.MAIN_SELECT_ACCOUNT,
            payload: {
                account_type: accountType,
                old_value: shadowString(oldValue, 'md5'),
                new_value: shadowString(newValue, 'md5'),
                source,
            },
        }));
    }, [accountType, dispatch]);

    return {
        handleAccountSelectClick,
        handleAccountSelectClose,
    }
}

export default useSelectAccountsHandlers;